/**
 * MergeTagChips — the tags the BE's renderer knows (render.KnownTags).
 * One row per editor, not per step: it inserts into whichever subject/body
 * field the caret was last in, so a single set of chips serves every step.
 * `{sender}` is a name-only tag for greetings and body text, never a sign-off —
 * the signature is appended at send time (U3).
 */
import { Button } from '../../../components/ui/button';
import { KNOWN_MERGE_TAGS, type KnownMergeTag } from './templateValidation';

const TAG_LABELS: Partial<Record<KnownMergeTag, string>> = {
  sender: 'Sender first name',
  year: 'Campaign year',
  creator_name: 'Creator name',
};

export interface MergeTagChipsProps {
  /** Receives the full `{tag}` text, ready to splice in at the caret. */
  onInsert: (tag: string) => void;
  disabled?: boolean;
}

export function MergeTagChips({ onInsert, disabled = false }: MergeTagChipsProps) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="text-caption-regular text-muted-foreground">Insert:</span>
      {KNOWN_MERGE_TAGS.map((tag) => (
        <Button
          key={tag}
          type="button"
          variant="outline"
          size="xs"
          disabled={disabled}
          onClick={() => onInsert(`{${tag}}`)}
          title={`{${tag}}`}
          className={TAG_LABELS[tag] ? undefined : 'font-mono'}
        >
          {TAG_LABELS[tag] ?? `{${tag}}`}
        </Button>
      ))}
    </div>
  );
}
